import { createPostGraphqlRequest } from '@tv2/lib-core/request';
import { defaultHeaders } from '../config/headers';
import endpoints from '../config/endpoints';
import { getChromecastMediaCapabilities } from '../utils/deviceDetector';
import { PlayChromecastContentPlaybackToken } from './__generated__/Token';

const operationName = 'play_chromecast_content_Playback_token';

/**
 * Get new JWT for DRMToday DRM request.
 * @param {string} guid Id of the content.
 * @param {string} user User object.
 * @return {Promise} Promise resolving with media object or rejecting with error.
 * @fulfil {Object}
 * @reject {cast.framework.messages.ErrorData}
 */
export default async function getToken(guid: string, user: any) {
  const mediaCapabilities = await getChromecastMediaCapabilities();

  const { accessToken } = user;

  const variables = {
    guid,
    ...mediaCapabilities,
  };

  const response = await createPostGraphqlRequest(
    endpoints.api,
    PlayChromecastContentPlaybackToken,
    variables,
    operationName,
    {
      ...defaultHeaders(),
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    }
  );

  return response?.drmLicense;
}
